import { render, staticRenderFns } from "./AddConfigModal.vue?vue&type=template&id=c6aa17a4"
import script from "./AddConfigModal.vue?vue&type=script&lang=js"
export * from "./AddConfigModal.vue?vue&type=script&lang=js"
import style0 from "./AddConfigModal.vue?vue&type=style&index=0&id=c6aa17a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports